
// States
import Vue from "vue";
import {apiModel, makeApiRequest} from "../../../api";
import {store} from "../../store";
import router from "../../../router/router";
import AppConfig from "../../../constants/AppConfig";

const state = {
    cardioExams: [],
    cardioExam: {},
};

// Getters
const getters = {

    cardioExams: state => {
        return state.cardioExams
    },

    cardioExam: state => {
        return state.cardioExam
    },
};

// Actions
const actions = {
    getCardioExams(context, payload) {
        function successCallback(response) {
            context.commit('getCardioExamsHandler', {examens: response.data.examens});
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Examen.Cardio.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getCardioExam(context, payload) {
        function successCallback(response) {
            context.commit('getCardioExamHandler', {examen: response.data.examen});
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Examen.Cardio.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateCardioExam(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'cardiology-exam' });

            router.push({ name: 'cardiology-exam', params: { cardiology: response.data.examen.slug } });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Examen.Cardio.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createCardioExam(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'cardiology-exam', params: { cardiology: response.data.examen.slug } });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Examen.Cardio.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteCardioExam(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'consultation-cardiology', params: { consultation: response.data.examen.cardiologie.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Examen.Cardio.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getCardioExamsHandler(state, {examens}) {
        // Update institutions state
        state.cardioExams = examens;
    },

    getCardioExamHandler(state, {examen}) {
        // Update institution state
        state.cardioExam = examen;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}